import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import zh from './zh' //中文简体
import en from './en' //英语
import cn from './cn' //中文繁体
import es from './es' //西班牙语
import fr from './fr' //法语 
import gr from './gr' //希腊
import italy from './italy' //意大利
import jp from './jp' //日本
import kor from './kor' //韩国
import pt from './pt' //葡萄牙
import th from './th' //泰国
import vi from './vi' //越南语
import de from './de' //德语
import india from './india' //印度

let locale = window.localStorage.getItem('lang') || '';
if (locale == '') {
    locale = 'en';
    window.localStorage.setItem('lang', locale);
}
export default new VueI18n({
    locale: locale,
    messages: {
        zh: zh,
        en: en,
        es: es,
        cn: cn,
        fr: fr,
        gr: gr,
        italy: italy,
        jp: jp,
        kor: kor,
        india: india,
        th: th,
        pt: pt,
        vi: vi,
        de: de
    }
})


// WEBPACK FOOTER //
// ./src/lang/lang.js